import { motion } from 'framer-motion';
import { PageHero, SectionHeader } from '@/components/common/Sections';
import { CTABanner } from '@/components/common/Cards';
import { GROUP_COMPANIES, IMAGES } from '@/lib/constants';
import { ArrowRight } from '@phosphor-icons/react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';

export default function GroupCompaniesPage() {
  return (
    <div className="page-transition">
      <PageHero
        title="Group Companies"
        subtitle="Five specialized companies, one unified vision for travel excellence"
        backgroundImage={IMAGES.corporateTravel}
      />

      <section data-testid="companies-list" className="section-padding bg-white">
        <div className="container-custom">
          <SectionHeader
            overline="Our Portfolio"
            title="The Osaka Group of Companies"
            description="Each company within Osaka Group is dedicated to a specific segment, ensuring specialized expertise and exceptional service delivery."
          />

          <div className="space-y-16">
            {GROUP_COMPANIES.map((company, index) => (
              <motion.div
                key={company.id}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                data-testid={`company-detail-${company.id}`}
                className={`grid lg:grid-cols-2 gap-12 items-center ${
                  index % 2 === 1 ? 'lg:grid-flow-dense' : ''
                }`}
              >
                <div className={index % 2 === 1 ? 'lg:col-start-2' : ''}>
                  <div
                    className="h-1 w-16 mb-6"
                    style={{ backgroundColor: company.color }}
                  />
                  <h3 className="text-3xl font-bold font-['Playfair_Display'] text-[#0A1F3D] mb-2">
                    {company.name}
                  </h3>
                  <p className="text-[#D4AF37] font-medium mb-6">{company.tagline}</p>
                  <p className="text-[#4A5568] leading-relaxed mb-8">
                    {company.description}
                  </p>
                  
                  <div className="mb-8">
                    <h4 className="text-sm font-bold text-[#0A1F3D] mb-4 tracking-wider uppercase">
                      Key Services
                    </h4>
                    <div className="flex flex-wrap gap-3">
                      {company.services.map((service, i) => (
                        <span
                          key={i}
                          className="px-4 py-2 bg-[#F5F5F5] text-[#4A5568] text-sm"
                        >
                          {service}
                        </span>
                      ))}
                    </div>
                  </div>

                  <Link to="/contact">
                    <Button
                      variant="outline"
                      className="border-[#0A1F3D] text-[#0A1F3D] hover:bg-[#0A1F3D] hover:text-white rounded-none"
                    >
                      Enquire Now <ArrowRight size={18} className="ml-2" />
                    </Button>
                  </Link>
                </div>

                <div
                  className={`relative aspect-[4/3] ${
                    index % 2 === 1 ? 'lg:col-start-1 lg:row-start-1' : ''
                  }`}
                >
                  <div
                    className="absolute inset-0 flex items-center justify-center"
                    style={{ backgroundColor: company.color + '10' }}
                  >
                    <div className="text-center p-12">
                      <div
                        className="text-6xl font-bold font-['Playfair_Display'] mb-4"
                        style={{ color: company.color }}
                      >
                        0{index + 1}
                      </div>
                      <div className="text-2xl font-bold font-['Playfair_Display'] text-[#0A1F3D]">
                        {company.name}
                      </div>
                    </div>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      <CTABanner />
    </div>
  );
}
